import React, { useState } from 'react';
import { HeroSection } from './HeroSection';
import { PainSection } from './PainSection';
import { SolutionSection } from './SolutionSection';
import { BenefitsSection } from './BenefitsSection';
import { IncludesSection } from './IncludesSection';
import { AudienceSection } from './AudienceSection';
import { CTASection } from './CTASection';
import { LegalModal, PrivacyContent, TermsContent } from './LegalModal';
export function SalesPage() {
  const [privacyOpen, setPrivacyOpen] = useState(false);
  const [termsOpen, setTermsOpen] = useState(false);
  return <main className="min-h-screen w-full bg-cream-100 overflow-x-hidden" data-id="element-153">
      <HeroSection data-id="element-154" />
      <PainSection data-id="element-155" />
      <SolutionSection data-id="element-156" />
      <BenefitsSection data-id="element-157" />
      <IncludesSection data-id="element-158" />
      <AudienceSection data-id="element-159" />
      <CTASection data-id="element-160" />

      <footer className="py-8 text-center text-charcoal-light/50 text-sm bg-cream-200" data-id="element-161">
        <div className="flex items-center justify-center gap-3 mb-2" data-id="element-162">
          <button onClick={() => setPrivacyOpen(true)} className="underline hover:text-terracotta transition-colors" data-id="element-163">
            Política de Privacidad
          </button>
          <span data-id="element-164">•</span>
          <button onClick={() => setTermsOpen(true)} className="underline hover:text-terracotta transition-colors" data-id="element-165">
            Términos y Condiciones
          </button>
        </div>
        <p data-id="element-166">© 2026 Mis Manos, Mi Calma. Todos los derechos reservados.</p>
      </footer>

      <LegalModal isOpen={privacyOpen} onClose={() => setPrivacyOpen(false)} title="Política de Privacidad" data-id="element-167">
        <PrivacyContent data-id="element-168" />
      </LegalModal>

      <LegalModal isOpen={termsOpen} onClose={() => setTermsOpen(false)} title="Términos y Condiciones" data-id="element-169">
        <TermsContent data-id="element-170" />
      </LegalModal>
    </main>;
}